import { z } from 'zod';
import { CONTENT_REPORT_HIDE_THRESHOLD } from './reports.js';
import { idSchema } from './common.js';
/** Media payloads (Phase 1). Files are always re-encoded server-side (resize, EXIF/GPS stripped). */
export const MEDIA_KINDS = ['recipe', 'ingredient', 'list_item', 'other'];
export const mediaKindSchema = z.enum(MEDIA_KINDS);
export const MEDIA_SCOPES = ['household', 'shared'];
export const mediaScopeSchema = z.enum(MEDIA_SCOPES);
/** Hard limits enforced by the API; the clients use them for early validation. */
export const MEDIA_MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
export const MEDIA_MAX_PIXELS = 50_000_000;
export const MEDIA_FULL_MAX_EDGE = 2048;
export const MEDIA_THUMB_MAX_EDGE = 400;
export const mediaDtoSchema = z.object({
    id: idSchema,
    kind: mediaKindSchema,
    scope: mediaScopeSchema,
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    bytes: z.number().int().nonnegative(),
    mime: z.string(),
    /** Same-origin URLs: `/api/v1/media/:id` and `/api/v1/media/:id/thumb`. */
    url: z.string(),
    thumbUrl: z.string(),
    createdAt: z.iso.datetime(),
});
/** POST /api/v1/media — multipart field `file`; `kind`/`scope` as query params or multipart fields. */
export const uploadMediaQuerySchema = z.object({
    kind: mediaKindSchema.default('other'),
    /** `shared` is only accepted for kind `ingredient` (the shared photo layer, D12/D13). */
    scope: mediaScopeSchema.default('household'),
});
export const mediaIdParamsSchema = z.object({ id: idSchema });
/** Shared ingredient photos (never attributed to a household). */
export const ingredientPhotoDtoSchema = z.object({
    id: idSchema,
    mediaId: idSchema,
    url: z.string(),
    thumbUrl: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    createdAt: z.iso.datetime(),
});
export const ingredientPhotosResponseSchema = z.object({
    photos: z.array(ingredientPhotoDtoSchema),
});
/** POST /api/v1/media/ingredients/:ingredientId/photos response. */
export const ingredientPhotoUploadResponseSchema = z.object({
    photo: ingredientPhotoDtoSchema,
    media: mediaDtoSchema,
});
export const ingredientPhotoParamsSchema = z.object({ ingredientId: idSchema });
export const photoIdParamsSchema = z.object({ photoId: idSchema });
export const reportPhotoResponseSchema = z.object({
    ok: z.literal(true),
    /** True when this report crossed the auto-hide threshold. */
    hidden: z.boolean(),
});
/** Distinct households reporting a photo before it is hidden pending admin review. */
export const INGREDIENT_PHOTO_HIDE_THRESHOLD = CONTENT_REPORT_HIDE_THRESHOLD;
//# sourceMappingURL=media.js.map